/**
 * Course data helpers for game scoring.
 * All course data now comes from Supabase (via CourseSearch) and is
 * snapshotted into game_config.courseData at round creation.
 *
 * Legacy games (pre-snapshot) stored a course_id + tee_name referencing
 * hardcoded course data. The LEGACY_COURSES array preserves that data
 * so old completed rounds still render correctly.
 */

// Legacy hardcoded courses for games created before the snapshot system
const LEGACY_COURSES = [
  {
    id: 'kierland-1',
    name: 'Kierland - Acacia/Mesquite',
    shortName: 'Kierland 1',
    holes: 18,
    par: [5, 4, 4, 3, 5, 3, 4, 3, 5, 4, 4, 4, 3, 5, 4, 5, 3, 4],
    handicapIndex: [16, 8, 4, 18, 2, 12, 10, 14, 6, 11, 9, 17, 15, 5, 3, 7, 13, 1],
    tees: [
      { name: 'Cinder', rating: 72.5, slope: 127, totalYardage: 6913, yardages: [517, 417, 448, 171, 568, 190, 374, 219, 531, 395, 410, 333, 187, 521, 468, 547, 190, 427] },
      { name: 'Copper', rating: 69.2, slope: 123, totalYardage: 6319, yardages: [493, 386, 402, 142, 542, 162, 339, 189, 503, 353, 375, 293, 154, 498, 423, 497, 158, 410] },
      { name: 'Indigo', rating: 66.9, slope: 114, totalYardage: 5820, yardages: [468, 361, 369, 129, 488, 142, 310, 160, 485, 319, 349, 274, 132, 470, 369, 470, 142, 383] },
      { name: 'Turquoise', rating: 65.7, slope: 110, totalYardage: 5455, yardages: [468, 361, 369, 129, 418, 122, 310, 137, 485, 319, 307, 274, 110, 470, 338, 419, 142, 277] },
      { name: 'Lava', rating: 63.1, slope: 106, totalYardage: 4898, yardages: [423, 298, 284, 110, 418, 122, 232, 137, 409, 299, 307, 211, 110, 405, 338, 419, 99, 277] },
    ],
  },
  {
    id: 'kierland-2',
    name: 'Kierland - Ironwood/Acacia',
    shortName: 'Kierland 2',
    holes: 18,
    par: [4, 4, 3, 4, 3, 4, 5, 4, 5, 5, 4, 4, 3, 5, 3, 4, 3, 5],
    handicapIndex: [1, 5, 17, 7, 13, 11, 15, 9, 3, 16, 8, 4, 18, 2, 12, 10, 14, 6],
    tees: [
      { name: 'Cinder', rating: 72.8, slope: 128, totalYardage: 6976, yardages: [440, 418, 188, 423, 200, 412, 532, 431, 495, 517, 417, 448, 171, 568, 190, 374, 219, 531] },
      { name: 'Copper', rating: 69.3, slope: 122, totalYardage: 6245, yardages: [400, 388, 134, 374, 163, 374, 480, 359, 469, 484, 378, 394, 140, 536, 162, 331, 181, 498] },
      { name: 'Indigo', rating: 67.2, slope: 114, totalYardage: 5855, yardages: [377, 364, 119, 357, 139, 347, 456, 331, 453, 468, 361, 369, 129, 488, 142, 310, 160, 485] },
      { name: 'Turquoise', rating: 66.3, slope: 111, totalYardage: 5575, yardages: [352, 303, 105, 357, 139, 347, 432, 288, 453, 468, 361, 369, 129, 418, 122, 310, 137, 485] },
      { name: 'Lava', rating: 63.6, slope: 106, totalYardage: 4985, yardages: [352, 303, 105, 289, 87, 298, 432, 288, 398, 423, 298, 284, 110, 418, 122, 232, 137, 409] },
    ],
  },
  {
    id: 'kierland-3',
    name: 'Kierland - Mesquite/Ironwood',
    shortName: 'Kierland 3',
    holes: 18,
    par: [4, 4, 4, 3, 5, 4, 5, 3, 4, 4, 4, 3, 4, 3, 4, 5, 4, 5],
    handicapIndex: [12, 10, 18, 16, 6, 4, 8, 14, 2, 1, 5, 17, 7, 13, 11, 15, 9, 3],
    tees: [
      { name: 'Cinder', rating: 73.1, slope: 127, totalYardage: 7017, yardages: [395, 410, 333, 187, 521, 468, 547, 190, 427, 440, 418, 188, 423, 200, 412, 532, 431, 495] },
      { name: 'Copper', rating: 69.7, slope: 123, totalYardage: 6340, yardages: [344, 367, 304, 171, 493, 414, 498, 162, 404, 400, 388, 134, 374, 163, 374, 480, 359, 469] },
      { name: 'Indigo', rating: 67.2, slope: 113, totalYardage: 5851, yardages: [319, 342, 284, 145, 464, 360, 469, 125, 375, 377, 364, 119, 357, 139, 347, 456, 331, 453] },
      { name: 'Turquoise', rating: 65.6, slope: 109, totalYardage: 5432, yardages: [319, 307, 284, 110, 464, 338, 419, 125, 277, 352, 303, 105, 357, 139, 347, 432, 288, 453] },
      { name: 'Lava', rating: 63.7, slope: 105, totalYardage: 5017, yardages: [299, 307, 211, 110, 405, 338, 419, 99, 277, 352, 303, 105, 289, 87, 298, 432, 288, 398] },
    ],
  },
  {
    id: 'whirlwind-devils-claw',
    name: 'Whirlwind - Devils Claw',
    shortName: 'Devils Claw',
    holes: 18,
    par: [4, 4, 5, 3, 4, 5, 3, 4, 4, 4, 4, 3, 4, 3, 5, 4, 5, 4],
    handicapIndex: [11, 17, 1, 13, 5, 7, 9, 15, 3, 16, 8, 4, 14, 10, 18, 12, 2, 6],
    tees: [
      { name: 'Black', rating: 72.7, slope: 127, totalYardage: 7029, yardages: [424, 399, 593, 190, 410, 564, 160, 317, 441, 407, 444, 222, 361, 172, 507, 425, 551, 442] },
      { name: 'Gold', rating: 70.3, slope: 123, totalYardage: 6487, yardages: [392, 366, 566, 159, 376, 535, 148, 289, 411, 376, 411, 191, 329, 142, 484, 387, 518, 407] },
      { name: 'Silver', rating: 68.1, slope: 119, totalYardage: 6039, yardages: [366, 342, 552, 140, 354, 506, 126, 265, 393, 344, 378, 163, 300, 121, 461, 360, 487, 381] },
      { name: 'Copper', rating: 65.4, slope: 111, totalYardage: 5492, yardages: [333, 316, 531, 121, 321, 477, 90, 240, 323, 322, 345, 136, 270, 98, 440, 330, 459, 340] },
    ],
  },
  {
    id: 'whirlwind-cattail',
    name: 'Whirlwind - Cattail',
    shortName: 'Cattail',
    holes: 18,
    par: [4, 5, 3, 4, 4, 3, 5, 4, 4, 3, 4, 5, 4, 4, 3, 4, 5, 4],
    handicapIndex: [9, 17, 15, 1, 7, 11, 3, 13, 5, 8, 4, 2, 10, 12, 18, 14, 16, 6],
    tees: [
      { name: 'Black', rating: 73.4, slope: 132, totalYardage: 7218, yardages: [413, 517, 162, 462, 337, 180, 599, 402, 431, 245, 481, 578, 441, 389, 143, 428, 560, 450] },
      { name: 'Gold', rating: 71.0, slope: 128, totalYardage: 6714, yardages: [392, 489, 147, 438, 311, 155, 554, 382, 403, 231, 443, 528, 421, 360, 136, 389, 515, 420] },
      { name: 'Silver', rating: 69.2, slope: 123, totalYardage: 6194, yardages: [360, 455, 127, 407, 277, 127, 517, 354, 360, 196, 411, 505, 389, 337, 124, 356, 488, 404] },
      { name: 'Copper', rating: 67.0, slope: 115, totalYardage: 5795, yardages: [330, 437, 116, 387, 252, 112, 484, 329, 336, 168, 391, 475, 366, 317, 107, 336, 466, 386] },
    ],
  },
]

function getLegacyCourse(courseId) {
  return LEGACY_COURSES.find((c) => c.id === courseId) || null
}

/**
 * Get course data for a game from its snapshotted courseData.
 * Falls back to legacy hardcoded courses for games created before the snapshot system.
 */
export function getGameCourse(gameData) {
  // Try snapshot first (new games)
  const snap = gameData?.game_config?.courseData
  if (snap) {
    return {
      id: snap.id,
      name: snap.name,
      shortName: snap.shortName,
      holes: snap.holes,
      par: snap.par,
      handicapIndex: snap.handicapIndex,
      tees: [snap.tee],
    }
  }

  // Fall back to legacy hardcoded courses (pre-snapshot games)
  if (gameData?.course_id) {
    return getLegacyCourse(gameData.course_id)
  }

  return null
}

/**
 * Get selected tee for a game from its snapshotted courseData.
 * Falls back to legacy hardcoded courses for games created before the snapshot system.
 */
export function getGameTee(gameData) {
  // Try snapshot first
  const snap = gameData?.game_config?.courseData
  if (snap?.tee) return snap.tee

  // Fall back to legacy lookup
  if (gameData?.course_id && gameData?.tee_name) {
    const course = getLegacyCourse(gameData.course_id)
    if (course) {
      return course.tees.find((t) => t.name === gameData.tee_name) || null
    }
  }

  return null
}

/**
 * Get mixed tees map from a game's snapshotted courseData.
 * @returns {Object|null} { [playerId]: teeObject } or null if no mixed tees configured
 */
export function getMixedTees(gameData) {
  return gameData?.game_config?.courseData?.mixedTees || null
}

/**
 * Get the tee for a specific player, accounting for mixed tees.
 * Falls back to the primary tee if the player has no override.
 */
export function getPlayerTee(gameData, playerId) {
  const mixedTees = getMixedTees(gameData)
  if (mixedTees && mixedTees[playerId]) return mixedTees[playerId]
  return getGameTee(gameData)
}
